import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { TipProvider } from './context/TipContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TipProvider>
      <App />
    </TipProvider>
  </React.StrictMode>
);

